<template>
  <div class="index container">

    <transition name="fade">
      <router-view @showParent="showParent">
      </router-view>
    </transition>

    <div v-if="showParentPage">

      <v-card elevation="0" outlined class="mt-5">

        <v-sheet class="pa-4 d-md-flex">

          <v-sheet class="flex-sm-column">
            <p class="text-h4 ma-0"> {{ terminologies.center }}</p>
          </v-sheet>

          <v-sheet class="flex-sm-column my-3 my-md-0">
            <v-breadcrumbs class="pa-md-3 pa-0">

              <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }">Home</v-breadcrumbs-item>
              <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
              <v-breadcrumbs-item :exact="true" :to="{ name: 'location', params: {} }" active>
                {{ terminologies.center }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-sheet>

          <v-spacer></v-spacer>

          <v-sheet class="flex-sm-column">

            <v-row>

              <v-col cols="12" md="7">

                <v-text-field dense v-model="searchTerms" @keyup.enter="search" @click:clear="clearSearch"
                  @click:append="search" rounded placeholder="Search Location" append-icon="mdi-magnify" outlined
                  clearable hide-details label="Search" />
              </v-col>

              <v-col cols="12" md="5">
                <v-btn class="align-self-end align-self-lg-start text-capitalize" color="primary" block text outlined
                  @click="locationDialog = true">
                  <v-icon>mdi-plus</v-icon>
                  Add {{ terminologies.center }}
                </v-btn>

              </v-col>

            </v-row>

          </v-sheet>

        </v-sheet>
      </v-card>


      <v-card elevation="0" class="mt-5">

        <div class="table-container">
          <v-data-table :headers="headers" :items="locationList" :items-per-page="pagination.pageSize"
            :loading="!locationProcessed" :server-items-length="pagination.totalSize" :page="pagination.current"
            :disable-pagination="!locationList || locationList.length < 1"
            :hide-default-header="!locationList || locationList.length < 1"
            :hide-default-footer="!locationList || locationList.length < 1" :options.sync="options" item-key="id"
            class="elevation-1" @update:options="pageChanged">

            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" @click="edit(item)">
                mdi-pencil
              </v-icon>
              <v-icon color="red" class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
    <confirmation-dialog ref="confirm" />


    <v-row justify="center">
      <v-dialog v-model="locationDialog" persistent max-width="600px">
        <v-card>
          <v-card-text>
            <location-form :key="locationId" :id="locationId" :isModal="true"
              @clicked="closeLocationDialog"></location-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
const ConfirmationDialog = () =>
  import("@/components/common/ConfirmationDialog.vue");
const LocationForm = () => import("@/components/location/LocationForm.vue");


export default {
  name: 'Locations',
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        totalSize: 100
      },
      options: { //define default sorting option here.
        sortBy: [],
        sortDesc: []
      },
      locationList: [],
      showParentPage: true,

      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
          sortable: true
        },
        // {
        //   text: "Code Name",
        //   value: "codeName",
        //   align: "start",
        //   sortable: false
        // },
        // {
        //   text: "Code",
        //   value: "code",
        //   align: "start",
        //   sortable: false
        // },

        {
          text: "Email",
          value: "email",
          align: "start",
          sortable: false
        },
        {
          text: "Phone Number",
          value: "phoneNumber",
          align: "start",
          sortable: false
        },
        {
          text: "Address",
          value: "address",
          align: "start",
          sortable: false
        },
        {
          text: "Coordinate",
          value: "lat",
          align: "start",
          sortable: false
        },
        // {
        //   text: "Longitude",
        //   value: "lng",
        //   align: "start",
        //   sortable: false
        // },
        {
          text: "Receipt Header",
          value: "receiptHeader",
          align: "start",
          sortable: false
        },
        {
          text: "Invoice Header",
          value: "invoiceHeader",
          align: "start",
          sortable: false
        },

        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
      sort: {
        key: null
      },
      searchTerms: '',

      locationDialog: false,
      locationId: null,
    }
  },
  components: {
    ConfirmationDialog,
    LocationForm
  },
  computed: {
    ...mapGetters("location", ["locationProcessed", "getLocations"]),
    ...mapGetters("terminology", ["terminologies"]),

  },
  methods: {
    ...mapActions("messages", [
      "addErrorMessage",
      "addMessage",
      "addSuccessMessage"
    ]),
    ...mapActions("location", ["deleteLocation", "fetchLocations"]),
    view(item) {
      this.$router.push({ name: 'locationView', params: { id: item.id } })
    },
    edit(item) {
      this.locationId = item.id;
      this.locationDialog = true;
    },
    async remove(item) {
      let confirm = await this.$refs.confirm.open(
        "Confirm Delete",
        "Do you want to delete this location?"
      );
      if (confirm) {
        this.deleteLocation(item.id)
          .then(() => {
            this.addSuccessMessage("location was deleted with successfull!");
            this.getResources();
          }).catch(() => {
            this.addErrorMessage("Server response with error ");
          });
      }
    },
    getResources() {
      //default to sorting by ID desc if not defined
      const sortBy =
        this.options["sortBy"] && this.options["sortBy"].length > 0
          ? this.options.sortBy[0]
          : "id";
      const sortDesc =
        this.options["sortDesc"] && this.options["sortDesc"].length > 0
          ? this.options.sortDesc[0]
          : true;
      const params = {
        page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex - 1 : 0,
        size: this.pagination.pageSize,
        sort: `${sortBy}${sortDesc ? ",desc" : ""}`,
      };
      this.fetchLocations(params)
        .then(response => {
          if (response) {
            this.pagination.totalSize = response.totalElements;
            this.locationList = response.content;
          }
        })
        .catch(error => {
          this.addErrorMessage("Server response with error " + error);
        });
    },
    showParent(show) {
      this.showParentPage = show;
    },
    pageChanged(pagination) {
      this.pagination.pageIndex = pagination.page;
      this.pagination.pageSize = pagination.itemsPerPage;
      this.getResources()
    },
    search() {
      this.getResources();
    },
    clearSearch() {
      this.searchTerms = null;
      this.getResources();
    },
    closeLocationDialog() {
      this.locationDialog = false;
      this.locationId = null;
      this.getResources()
    },
  },
  watch: {
    'pagination.numberRegisterForPage': function () {
      this.pagination.current = -1;
    },
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.showParentPage = toDepth < fromDepth;
    if (this.showParentPage) {
      this.getResources();
    }
    next();
  }
}
</script>

    